import React from "react";
import Sparkle from "./icons/sparkle.svg";

const NewFeature = ({ style = { width: "20px", height: "20px" } }) => {
    return (
        <>
            <style>
                {`
                    .new-feature-sparkle {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        animation: sparkle-twinkle 1.2s ease-in-out infinite;
                    }

                    @keyframes sparkle-twinkle {
                        0% {
                            transform: scale(1);
                        }

                        50% {
                            transform: scale(1.3);
                        }

                        100% {
                            transform: scale(1);
                        }
                    }
                `}
            </style>

            <div className="new-feature-sparkle" title="New Feature">
                <img src={Sparkle} style={style} />
            </div>
        </>
    );
};

export default NewFeature;